import React from 'react';
import Markdown from 'markdown-to-jsx';

import { TeamUser } from 'types/teamUser';
import { truncateAndEllipsis } from 'utils/truncate';

import { WebImage } from 'components/common/WebImage';
import { Avatar } from 'components/common/Avatar/';
import { FormatTeams } from 'components/common/FormatTeams';
import { ReadMoreButton } from 'components/common/ReadMoreButton';
import { Wrapper } from './atoms/Wrapper';
import { PersonWrapper } from './atoms/PersonWrapper';
import { AvatarWrapper } from './atoms/AvatarWrapper';
import { PersonInfo } from './atoms/PersonInfo';
import { Description } from './atoms/Description';

export interface ExpertiseHighlightProps {
    user: TeamUser;
    leadContent: string;
    isPurple?: boolean;
    title: string;
    slug: string;
    extraPaddingLeft?: boolean;
    extraPaddingRight?: boolean;
    type?: string;
    id: number;
}
export const ExpertiseHighlight: React.FC<ExpertiseHighlightProps> = (props) => {
    const {
        user,
        leadContent,
        type,
        slug,
        isPurple = false,
        extraPaddingLeft = false,
        extraPaddingRight = false,
    } = props;
    const { fullname, imageAttachments } = user;

    return (
        <Wrapper extraPaddingLeft={extraPaddingLeft} extraPaddingRight={extraPaddingRight} isPurple={isPurple}>
            <PersonWrapper>
                <AvatarWrapper>
                    <Avatar size="50px">
                        <WebImage
                            image={{
                                alt: fullname,
                                ...imageAttachments[0].image,
                            }}
                        />
                    </Avatar>
                </AvatarWrapper>
                <PersonInfo>
                    <h4>
                        {fullname} - <FormatTeams teams={user.teams} />
                    </h4>
                </PersonInfo>
            </PersonWrapper>
            <Description>
                <div>
                    <Markdown>{truncateAndEllipsis(70, leadContent)}</Markdown>
                </div>
            </Description>
            <div>
                <ReadMoreButton readMoreUrl={`/expertise/${slug}`} type={type} />
            </div>
        </Wrapper>
    );
};
